import { styled } from '@mui/material';

export const StyledApplicationLogo = styled('img')`
  width: 150px;
`;
